import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoConcedidoService from '../../servicos/DetalhesRecursoConcedidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaCronogramaDesembolsoRecursoConcedidoInicio: [],
    buscaCronogramaDesembolsoRecursoConcedidoSucesso: ['cronogramaDesembolsoRecursoConcedido'],
    buscaCronogramaDesembolsoRecursoConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaCronogramaDesembolsoRecursoConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaCronogramaDesembolsoRecursoConcedidoInicio())
        let serv = new DetalhesRecursoConcedidoService()
        return serv
            .consultarCronogramaDesembolso(filtro)
            .then(response => dispatch(Creators.buscaCronogramaDesembolsoRecursoConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaCronogramaDesembolsoRecursoConcedidoErro(error)))
    }
}

const buscaCronogramaDesembolsoRecursoConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaCronogramaDesembolsoRecursoConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaCronogramaDesembolsoRecursoConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.cronogramaDesembolsoRecursoConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CRONOGRAMA_DESEMBOLSO_RECURSO_CONCEDIDO_INICIO]: buscaCronogramaDesembolsoRecursoConcedidoInicio,
    [Types.BUSCA_CRONOGRAMA_DESEMBOLSO_RECURSO_CONCEDIDO_ERRO]: buscaCronogramaDesembolsoRecursoConcedidoErro,
    [Types.BUSCA_CRONOGRAMA_DESEMBOLSO_RECURSO_CONCEDIDO_SUCESSO]: buscaCronogramaDesembolsoRecursoConcedidoSucesso,
})
